import { combineReducers } from "redux";

import homepageReducer, { HomePageState } from "./HomePage.reducer.ts";
import AuthReducer, { AuthState } from "./Auth.reducer.ts";
import PreliminaryReducer, { PreliminaryState } from "./Preliminary.reducer.ts";
import LocationReducer, { LOCATIONState } from "./Locations.reducer.ts";
import LocationReducer2, { LOCATION2State } from "./Locations2.reducer.ts";
import AssessmentReducer, { AssessmentState } from "./Assessment.reducer.ts";
import WorkplanReducer, {WorkPlanState} from "./Workplan.reducer.ts";
import NewsReducer , {NewsState} from "./News.reducer.ts";
import NotificationReducer,{NotiState} from "./Notification.reducer.ts";
import OfficerAdminReducer, { OfficeAdminState } from "./Officer.Admin.reducer.ts";
import NewsAdminReducer, {NewsAdminState} from "./News.Admin.reducer.ts";
import ReportReducer,{ReportState} from "./Report.reducer.ts";
import ChildAdminReducer,{ChildAdminState} from "./Child.Admin.reducer.ts";
import ChildConnectAdminReducer, { ChildConnectAdminState } from "./ChildConnectAdmin.reducer.ts";
import DepartMentAdminReducer, { DepartmentAdminState } from "./DepartMentAdmin.reducer.ts";

export default combineReducers({
    homepageReducer,
    AuthReducer,
    PreliminaryReducer,
    LocationReducer,
    AssessmentReducer,
    WorkplanReducer,
    NewsReducer,
    NotificationReducer,
    OfficerAdminReducer,
    NewsAdminReducer,
    ReportReducer,
    ChildAdminReducer,
    ChildConnectAdminReducer,
    DepartMentAdminReducer,
    LocationReducer2,
});

export interface RootReducers {
    homepageReducer: HomePageState;
    AuthReducer: AuthState;
    PreliminaryReducer: PreliminaryState;
    LocationReducer: LOCATIONState;
    AssessmentReducer: AssessmentState;
    WorkplanReducer: WorkPlanState;
    NewsReducer:NewsState;
    NotificationReducer:NotiState;
    OfficerAdminReducer: OfficeAdminState;
    NewsAdminReducer: NewsAdminState;
    ReportReducer:ReportState;
    ChildAdminReducer:ChildAdminState;
    ChildConnectAdminReducer:ChildConnectAdminState;
    DepartMentAdminReducer:DepartmentAdminState;
    LocationReducer2: LOCATION2State;

} 